import React from "react";
import classNames from "classnames";
import Icon from "components/Icon";

const SelectInput = React.forwardRef(({
  id,
  dataCy,
  value,
  onChange,
  placeholder = "Please select an option",
  isDisabled = false,
  options = [],
  hasError = false,
  errorMessage = "Inline error message",
}, ref) => {
  const hasValue = value !== "";
  return (
    <div className="relative flex flex-col w-full">
      {/* Input Container */}
      <div
        className={classNames(
          "relative flex items-center w-full rounded-lg px-4 py-[14px] tw-paragraph-lg transition-all tw-input-wrapper  bg-white",
          hasError && "border border-[var(--color-alert)] hover-border-thicker-input-red",
          !hasError && !isDisabled && "border border-gray-100 hover-border-thicker-input",
          isDisabled ? "border border-gray-100 text-gray-400" : "",
          "after:content-[url('data:image/svg+xml,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M5%207.5L10%2012.5L15%207.5%22%20stroke%3D%22currentColor%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E')] after:absolute after:right-4 after:top-1/2 after:-translate-y-1/2 after:w-5 after:h-5 after:pointer-events-none"
        )}
      >
        {/* Text Input */}
        <select
          ref={ref}
          id={id}
          data-cy={dataCy}
          value={value}
          onChange={onChange}
          disabled={isDisabled}
          placeholder=" "
          className="peer w-full outline-none bg-transparent text-gray-900 font-semibold"
        >
          <option value="" disabled hidden>
          </option>
          {options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.name}
            </option>
          ))}
        </select>
          {/* Floating Label */}
        {placeholder && (
          <label
            htmlFor={id}
            className={classNames(
              "tw-paragraph-lg",
              "bg-transparent absolute px-1 left-4 text-gray-400 transition-all pointer-events-none",
              (hasValue ? "top-[-12px] text-sm -translate-y-0" : "top-1/2 -translate-y-1/2"),
              "transform",
              "peer-focus:top-[-12px] peer-focus:text-sm peer-focus:-translate-y-0",
              "peer-focus:bg-transparent peer-focus:z-10",
              "before:content-[''] before:absolute before:bottom-0 before:left-0 before:right-0 before:h-[13px] before:bg-white before:z-[-1] before:transform before:-translate-y-1/2"
            )}
          >
            {placeholder}
          </label>
        )}
      </div>

      {/* Error Message */}
      {hasError && !isDisabled && (
        <div className="absolute left-0 top-full flex items-center gap-2 text-gray-800 mt-1 ml-4">
          <Icon name="circleAlert" size={20} fillColor="fill-[var(--color-alert)]" className="text-[var(--color-white)]" />
          <span className="tw-paragraph-sm font-semibold">{errorMessage}</span>
        </div>
      )}
    </div>
  );
});

export default SelectInput;
